const AuthLayout = ({ children }) => <>{children}</>;

export default AuthLayout;
